// import HOST from "../config/host.config";
import axios from '../config/axios.config'
import qs from 'querystring'
const MergeUrl = '/'
const Merge = (_url) => {
  //拼接/api
  if (typeof _url === 'object' && _url.Merge && _url.Merge === false)
    return _url
  else return MergeUrl + _url
}

function removalAllScriptTag(obj) {
  let removeFromString = (str) => {
    if (typeof str == 'object') {
      return removalAllScriptTag(str)
    }
    let reg = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/\s*script>/gi
    while (reg.test(str)) {
      str = str.replace(reg, '')
    }
    return str
  }
  if (obj) {
    if (typeof obj == 'object') {
      for (let i in Object.keys(obj)) {
        obj[i] = removeFromString(obj[i])
      }
    } else if (typeof obj == 'string') {
      obj = removeFromString(obj)
    }
  }
  return obj
}

const request = {
  //初始化数据
  // async indexInit() {
  //   return axios.get(`${init.index}/?Id=3&PageId=170 `);
  // },
  // //发送文件
  // async uploadFile(File, FileType) {
  //   let formData = new FormData();
  //   formData.append("File", File);
  //   formData.append("OperationRecordID", 3);
  //   formData.append("FileType", FileType);
  //   formData.append("UploadType", 1);
  //   return axios.post(submit.uploadFile, formData);
  //   // File,
  //   //   OperationRecordID: 3,
  //   //   FileType,
  //   //   UploadType: 1
  // },
  //提交文件
  // async submit(data) {
  //   return axios.post(submit.index, data);
  // },
  //post
  async post(url, data = null) {
    data = removalAllScriptTag(data)
    return axios.post(Merge(url), data)
  },
  async post2(url, data) {
    data = removalAllScriptTag(data)
    return axios.post(Merge(url), data, {
      headers: { 'Content-Type': 'multipart/form-data' },
      transformRequest(data) {
        return qs.stringify(data, '&')
      },
    })
  },
  //get
  async get(url, data = null) {
    data = removalAllScriptTag(data)
    return axios.get(Merge(url), { params: { ...data } })
  },
  //delete
  async del(url, data = null, para = true) {
    data = removalAllScriptTag(data)
    return axios.delete(
      Merge(url),
      para === true ? { params: { ...data } } : { data }
    )
  },
  // upload file
  async upload(url, data) {
    data = removalAllScriptTag(data)
    return axios.post(Merge(url), data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  // get request width data in body
  async getBody(url, data) {
    return axios.get(Merge(url), { data })
  },
}

export default request
